<template>
<div class="vliveSignUp">
    <div>
        <!--<el-switch v-model="signUp.isopenenroll" active-text="关闭后，观看端将不会显示此关注栏" @change="switchStatus"></el-switch>-->
        <span class="switch"  @click.stop="switchStatus">
            <el-switch v-model="signUp.isopenenroll" active-text="关闭后，观看端将不会显示此关注栏" disabled></el-switch>
        </span>
    </div>
    <div class="dialog-form form signup" v-if="signUp.isopenenroll">
        <el-form :model="signUp" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm" label-position="left" size="mini">
            <!-- <el-form-item label="按钮图片" class="upload-image" required> -->
                <!--<upload class="icon" :imgRule="imgRule" @setImage="_setImage"></upload>-->
                <!-- <div class="upload icon" @click="openLocalGallery">
                    <div class="avatar-uploader">
                        <div tabindex="0" class="el-upload el-upload--text">
                            <i class="el-icon-plus avatar-uploader-icon icon_default_image" v-if="!signUp.coverPicture.furl"></i>
                            <img :src="signUp.coverPicture.furl +'?'+timestamp" alt="" class="avatar" v-if="signUp.coverPicture.furl">
                        </div>
                    </div>
                </div>
                <div class="el-upload__tip">建议：100*100像素，PNG格式，大小不超过500K</div>
            </el-form-item> -->
            <el-form-item label="跳转链接" prop="enrollurl">
                <el-input v-model.trim="signUp.enrollurl" placeholder="请输入跳转链接" clearable></el-input>
            </el-form-item>
            <el-form-item>
                <el-button type="primary" @click="submitForm">保存</el-button>
            </el-form-item>
        </el-form>
    </div>
    <localCropper :cropperOption="cropperOption" ref="localCropper" @setImage="setImage" :uploadType="uploadType"></localCropper>
</div>
</template>

<script>
import LocalCropper from 'base/cropper/localCropper'
import {mapGetters, mapActions} from 'vuex'
import {editVliveSingUpStatus, editVliveSingUp} from 'api/api'
import {formatFileInfo} from 'common/js/tools'
import {vliveMsg} from 'api/message'
export default {
    name: 'vliveSignUp',
    data() {
        return {
            timestamp: new Date().getTime(), // 时间戳
            signUp: {
                isopenenroll: false,
                coverPicture: {
                    bucket: '',
                    fname: '',
                    fsize: '',
                    width: '',
                    height: '',
                    key: '',
                    mimeType: '',
                    objecttype: '',
                    furl: ''
                },
                enrollurl: ''
            },
            uploadType: {
                catecode: '95',
                datatype: 'IMAGE'
            },
            cropperOption: {
                fixedNumber: [100, 100], // 截图框的宽高比例
                enlarge: 1, // 图片根据截图框输出比例倍数
                autoCropWidth: 100, // 默认生成截图框宽度
                autoCropHeight: 100 // 默认生成截图框高度
            },
            rules: {
                enrollurl: [
                    {required: true, message: '请输入跳转链接', trigger: 'blur'},
                    {min: 3, max: 200, message: '长度在3到200个字符', trigger: 'blur'}
                ]
            },
            settingType: 'isopenenroll' // isopenpreview 预告片 isopencover 引导封面 isopenmp 关注公众号 isopenenroll 报名
        }
    },
    mounted() {
    },
    methods: {
        // 设置上传图片信息
        setImage(file) {
            this.timestamp = new Date().getTime()
            this.signUp.coverPicture = file
        },
        // 打开剪裁框
        openLocalGallery() {
            this.$refs.localCropper.openDialog()
        },
        // 开启/关闭报名
        switchStatus() {
            let status = !this.signUp.isopenenroll ? 1 : 0
            let tip = !this.signUp.isopenenroll ? '开启报名' : '关闭报名'
            this.$confirm(`确定${tip}？`, '提示', {
                cancelButtonText: '取消',
                confirmButtonText: '确定'
            }).then(() => {
                this._editStatus(status, tip)
            })
        },
        // 提交报名信息
        submitForm() {
            this.$refs.ruleForm.validate((valid) => {
                if (valid) {
                    this.$confirm(vliveMsg.submitSignUp.msg, vliveMsg.submitSignUp.title, {
                        confirmButtonText: vliveMsg.submitSignUp.confirmText,
                        cancelButtonText: vliveMsg.submitSignUp.cancelText
                    }).then(() => {
                        this._editSignUp()
                    })
                }
            })
        },
        // 提交关闭/开启报名
        _editStatus (status, tip) {
            this.setLoading(true)
            editVliveSingUpStatus({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    settingType: this.settingType,
                    settingValue: status
                },
                success: data => {
                    this.$message.success(`${tip}成功！`)
                    this.signUp.isopenenroll = !this.signUp.isopenenroll
                    this.setVliveModelSignUp(Object.assign({}, this.signUp))
                    this.setLoading(false)
                },
                error: data => {
                    this.signUp.isopenenroll = !this.signUp.isopenenroll
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        // 提交开启报名信息
        _editSignUp () {
            this.setLoading(true)
            editVliveSingUp({
                data: {
                    assetinnerid: this.vliveModel.assetinnerid,
                    coverPicture: formatFileInfo(this.signUp.coverPicture),
                    enrollurl: this.signUp.enrollurl
                },
                success: data => {
                    this.$message.success(vliveMsg.submitSignUp.successMsg)
                    this.setVliveModelSignUp(Object.assign({}, this.signUp))
                    this.setLoading(false)
                },
                error: data => {
                    this.setLoading(false)
                    this.$message.error(data.msg)
                }
            })
        },
        ...mapActions([
            'setVliveModelSignUp',
            'setLoading'
        ])
    },
    filters: {},
    watch: {
        vliveModel: {
            handler: function() {
                this.signUp = Object.assign({}, this.vliveModel.signUp)
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters([
            'vliveModel'
        ])
    },
    components: {
        LocalCropper
    }
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
@import "~common/scss/mixin";
.vliveSignUp {
    .signup{
        margin-top: 20px;
    }
    .upload-image{
        .el-form-item__content{
            @include flexBox(flex-start);
            .upload{
                margin-right: 20px;
            }
            .el-upload__tip{
                align-self: flex-end;
            }
        }
        .upload .avatar-uploader .el-upload{
            border-radius: 50%;
        }
        .icon, .avatar-uploader{
            box-sizing: border-box;
            height: 100px;
            width: 100px;
        }
    }
}
</style>
